import { Directive, Output, EventEmitter, ElementRef, AfterViewInit } from "@angular/core";

/* how to used
    loadMore() {
        console.log("load more");
    }
    <div class="prime-card-body" footerVisibleScroll (footerVisible)="isFooterVisible = $event"

    for .ts
    isFooterVisible = true;

    style.scss
    .footer {
        display: none;
        transform: translateY(20px);
        transition: 0.3s ease;
    }

    .footer.show {
        display: block;
        transform: translateY(0);
    }
*/
@Directive({
    selector: "[footerVisibleScroll]",
})
export class FooterVisibleScrollDirective implements AfterViewInit {
    @Output() footerVisible = new EventEmitter<boolean>();

    private element!: HTMLElement;

    constructor(private el: ElementRef) {}

    ngAfterViewInit(): void {
        this.element = this.el.nativeElement;

        // run on default load
        this.checkFooterVisibility();

        // run on scroll
        this.element.addEventListener("scroll", () => {
            this.checkFooterVisibility();
        });
    }

    private checkFooterVisibility(): void {
        const scrollTop = this.element.scrollTop;
        const clientHeight = this.element.clientHeight;
        const scrollHeight = this.element.scrollHeight;

        // if no scroll OR reached bottom → show footer
        const showFooter = scrollHeight <= clientHeight || scrollTop + clientHeight >= scrollHeight - 5;

        this.footerVisible.emit(showFooter);
    }
}
